import { BaseDto } from "@models/base/baseDto.model"

export class TipoAjusteContratoDto extends BaseDto {
  public acronimo!: string
  public fechaAlta!: Date
  public fechaModificacion?: Date
}
